(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-recommendations]').forEach(root => {
      if(root.dataset.ready) return; root.dataset.ready='true';
      fetch(root.dataset.url).then(response => {if(!response.ok) throw new Error('Recommendations unavailable');return response.text();}).then(html => {
        if(!root.isConnected)return;
        const documentFragment=new DOMParser().parseFromString(html,'text/html');
        const result=documentFragment.querySelector('[data-recommendations]');
        if(result)root.innerHTML=result.innerHTML;
      }).catch(()=>{});
    });
    scope.querySelectorAll('[data-reveal]').forEach(el => {
      if (!('IntersectionObserver' in window)) { el.classList.add('revealed'); return; }
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if(entry.isIntersecting){ entry.target.classList.add('revealed'); observer.disconnect(); }
      }), {threshold: .08});
      observer.observe(el);
    });
    scope.querySelectorAll('[data-header]').forEach(header => {
      if(header.dataset.ready) return; header.dataset.ready = 'true';
      const toggle = header.querySelector('[data-menu-toggle]');
      const nav = header.querySelector('[data-mobile-nav]');
      const close = () => { nav.classList.remove('open'); toggle.setAttribute('aria-expanded','false'); };
      toggle?.addEventListener('click', () => { const open = nav.classList.toggle('open'); toggle.setAttribute('aria-expanded', String(open)); });
      nav?.addEventListener('click', e => { if(e.target.closest('a')) close(); });
      header.addEventListener('keydown', e => { if(e.key === 'Escape') {close(); toggle.focus();} });
    });
    scope.querySelectorAll('[data-product-section]').forEach(root => {
      if(root.dataset.ready) return; root.dataset.ready='true';
      const select = root.querySelector('[data-product-variant]');
      select?.addEventListener('change', () => {
        root.querySelector('[data-product-price]').textContent = select.selectedOptions[0].dataset.price;
        const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      });
    });
    scope.querySelectorAll('.quick-buy-form').forEach(form => {
      if(form.dataset.quickReady) return; form.dataset.quickReady='true';
      const price=form.querySelector('[data-quick-price]');
      const sync=()=>{
        const selected=form.querySelector('[data-quick-variant]:checked');
        if(price && selected?.dataset.price) price.textContent=selected.dataset.price;
      };
      form.addEventListener('change', event => {if(event.target.matches('[data-quick-variant]')) sync();});
      sync();
    });
    scope.querySelectorAll('[data-vyre-carousel]').forEach(root => {
      if(root.dataset.ready) return; root.dataset.ready = 'true';
      const slides = [...root.querySelectorAll('[data-slide]')];
      if(!slides.length) return;
      let current = Math.min(3, slides.length-1);
      const choose = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide,i) => {
          let diff = i-current;
          if(diff>slides.length/2) diff-=slides.length;
          if(diff<-slides.length/2) diff+=slides.length;
          slide.classList.remove('pos-far-left','pos-left','pos-center','pos-right','pos-far-right');
          slide.classList.add(diff<=-2?'pos-far-left':diff===-1?'pos-left':diff===0?'pos-center':diff===1?'pos-right':'pos-far-right');
          slide.style.visibility = Math.abs(diff)>2?'hidden':'visible';
          slide.querySelector('button').tabIndex = Math.abs(diff)>2?-1:0;
        });
        root.querySelectorAll('[data-choose]').forEach(button => {
          const active=Number(button.dataset.choose)===current;
          button.classList.toggle('is-active', active); button.setAttribute('aria-pressed',String(active));
        });
        root.querySelectorAll('[data-buy-panel]').forEach(panel => panel.hidden=Number(panel.dataset.buyPanel)!==current);
        const selected = slides[current];
        root.style.setProperty('--selected', selected.dataset.accent);
        const glow = `color-mix(in srgb, ${selected.dataset.accent} 34%, transparent)`;
        root.style.setProperty('--glow', glow);
        document.documentElement.style.setProperty('--glow', glow);
        const images = JSON.parse(selected.querySelector('[data-slide-images]').textContent);
        document.querySelectorAll('[data-sync-image][data-follow="true"]').forEach(wrap => {
          const img = wrap.querySelector('img'); const src = images[wrap.dataset.syncImage];
          if(img && src) {img.removeAttribute('srcset'); img.src=src; img.alt=selected.querySelector('strong').textContent + ' ' + wrap.dataset.syncImage;}
        });
      };
      root.addEventListener('click', e => {
        const button=e.target.closest('[data-choose]'); if(button) choose(Number(button.dataset.choose));
        if(e.target.closest('[data-prev]')) choose(current-1);
        if(e.target.closest('[data-next]')) choose(current+1);
      });
      root.querySelector('.carousel-stage').addEventListener('keydown', e => {
        if(e.key==='ArrowLeft' || e.key==='ArrowRight'){e.preventDefault();choose(current+(e.key==='ArrowLeft'?-1:1));}
      });
      root.addEventListener('shopify:block:select', e => {
        const index=slides.findIndex(slide=>slide.dataset.blockId===e.detail.blockId); if(index>=0)choose(index);
      });
      let startX;
      const stage=root.querySelector('.carousel-viewport');
      stage.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;},{passive:true});
      stage.addEventListener('touchend',e=>{const diff=e.changedTouches[0].clientX-startX;if(Math.abs(diff)>50)choose(current+(diff<0?1:-1));},{passive:true});
      root.querySelectorAll('[data-prev],[data-next]').forEach(button=>button.hidden=slides.length<2);
      choose(current);
    });
  }
  init();
  document.addEventListener('shopify:section:load',e => init(e.target));
  document.addEventListener('shopify:section:reorder',() => init());
})();

/* Product experience, predictive search and bag drawer. */
(() => {
  const theme = window.VYRE_THEME || {};
  const root = theme.rootUrl || '/';
  const money = cents => {
    const format = theme.moneyFormat || '${{amount}}';
    const amount = Number(cents || 0) / 100;
    const match = format.match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?)\s*\}\}/);
    if (!match) return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:theme.currency || 'USD'}).format(amount);
    const comma = match[1].includes('comma_separator');
    const precision = match[1].includes('no_decimals') ? 0 : 2;
    const formatted = new Intl.NumberFormat(comma ? 'de-DE' : 'en-US', {minimumFractionDigits:precision, maximumFractionDigits:precision}).format(amount);
    return format.replace(match[0], formatted).replace(/<[^>]+>/g, '').trim();
  };
  const overlay = document.querySelector('[data-vyre-overlay]');
  const searchPanel = document.querySelector('[data-vyre-search]');
  const cartPanel = document.querySelector('[data-vyre-cart]');
  let previousFocus;
  let activePanel;
  const closePanel = () => {
    if (!activePanel) return;
    activePanel.hidden = true;
    overlay.hidden = true;
    document.body.classList.remove('vyre-panel-open');
    activePanel = null;
    previousFocus?.focus();
  };
  const openPanel = panel => {
    if (!panel || !overlay) return;
    if (activePanel) closePanel();
    previousFocus = document.activeElement;
    activePanel = panel;
    panel.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('vyre-panel-open');
    panel.querySelector('input,button')?.focus();
  };
  overlay?.addEventListener('click', closePanel);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closePanel();
    if (event.key !== 'Tab' || !activePanel) return;
    const focusable = [...activePanel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el => !el.closest('[hidden]'));
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) {event.preventDefault();focusable.at(-1).focus();}
    else if (!event.shiftKey && document.activeElement === focusable.at(-1)) {event.preventDefault();focusable[0].focus();}
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open-search]')) {openPanel(searchPanel); return;}
    if (event.target.closest('[data-open-cart]')) {openPanel(cartPanel); refreshCart(); return;}
    if (event.target.closest('[data-close-search],[data-close-cart]')) closePanel();
  });
  const results = document.querySelector('[data-search-results]');
  const searchInput = document.querySelector('[data-search-input]');
  let searchTimer, searchController;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchController?.abort();
    const q = searchInput.value.trim();
    if (!q) {results.innerHTML = '<p>Start typing to find your next piece.</p>';return;}
    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      const params = new URLSearchParams({q, 'resources[type]':'product', 'resources[limit]':'6', section_id:'vyre-predictive-search'});
      try {
        const response = await fetch(`${root}search/suggest?${params}`, {signal:searchController.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const matching = doc.querySelector('[data-predictive-results]');
        if (matching && searchInput.value.trim() === q) {
          results.replaceChildren(...matching.childNodes);
          const more = document.createElement('a');more.className='vyre-search__all';
          more.href = `${theme.searchUrl || root + 'search'}?${new URLSearchParams({q,type:'product'})}`;
          more.textContent = `View all results for “${q}” →`;
          results.append(more);
        }
      } catch(error) {if (error.name !== 'AbortError') results.textContent = 'Search is temporarily unavailable. Press Enter to see all products.';}
    }, 220);
  });
  const cartItems = document.querySelector('[data-drawer-items]');
  const renderCart = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    document.querySelector('[data-drawer-count]').textContent = cart.item_count;
    document.querySelector('[data-drawer-foot]').hidden = !cart.item_count;
    document.querySelector('[data-drawer-total]').textContent = money(cart.total_price);
    cartItems.replaceChildren();
    if (!cart.items.length) {
      const empty = document.createElement('div');empty.className='vyre-drawer__empty';
      empty.innerHTML='<span aria-hidden="true">✦</span><h3>Your bag is waiting.</h3><p>Find a piece that feels like you.</p>';
      const link=document.createElement('a');link.href=root+'collections/all';link.textContent='Explore the collection →';empty.append(link);cartItems.append(empty);return;
    }
    cart.items.forEach(item => {
      const row=document.createElement('div');row.className='vyre-drawer__item';
      const pic=document.createElement('a');pic.href=item.url;
      if(item.image){const img=document.createElement('img');img.src=item.image;img.alt=item.product_title;img.loading='lazy';pic.append(img);}
      const details=document.createElement('div');details.className='vyre-drawer__item-details';
      const title=document.createElement('a');title.href=item.url;title.textContent=item.product_title;title.className='vyre-drawer__item-title';details.append(title);
      if(item.variant_title && item.variant_title !== 'Default Title'){const variant=document.createElement('small');variant.textContent=item.variant_title;details.append(variant);}
      const price=document.createElement('strong');price.textContent=money(item.final_line_price);details.append(price);
      const controls=document.createElement('div');controls.className='vyre-drawer__controls';
      const down=document.createElement('button');down.type='button';down.textContent='−';down.setAttribute('aria-label','Decrease quantity');down.dataset.lineKey=item.key;down.dataset.quantity=item.quantity-1;
      const count=document.createElement('span');count.textContent=item.quantity;
      const up=document.createElement('button');up.type='button';up.textContent='+';up.setAttribute('aria-label','Increase quantity');up.dataset.lineKey=item.key;up.dataset.quantity=item.quantity+1;
      const remove=document.createElement('button');remove.type='button';remove.textContent='Remove';remove.className='vyre-drawer__remove';remove.dataset.lineKey=item.key;remove.dataset.quantity='0';
      controls.append(down,count,up,remove);details.append(controls);row.append(pic,details);cartItems.append(row);
    });
  };
  async function refreshCart(){
    try {const response=await fetch(`${root}cart.js`);if(!response.ok)throw Error();renderCart(await response.json());}
    catch {cartItems.textContent='Could not load the bag. Please open the full cart.';}
  }
  cartItems?.addEventListener('click', async event => {
    const button=event.target.closest('[data-line-key]');if(!button)return;
    button.disabled=true;
    try {
      const response=await fetch(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.lineKey,quantity:Number(button.dataset.quantity)})});
      const data=await response.json();if(!response.ok)throw Error(data.description || 'Could not update your bag');renderCart(data);
    } catch(error) {cartItems.insertAdjacentText('afterbegin', error.message + ' ');button.disabled=false;}
  });
  function initProduct(section) {
    if(section.dataset.pdpReady)return;section.dataset.pdpReady='true';
    const variants=JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const media=[...section.querySelectorAll('[data-media-id]')];
    const showMedia=id=>{
      if(!media.length)return;
      const target=media.find(el=>el.dataset.mediaId===String(id)) || media[0];
      media.forEach(el=>{el.hidden=el!==target;el.classList.toggle('is-active',el===target);});
      section.querySelectorAll('[data-media-target]').forEach(el=>{const active=el.dataset.mediaTarget===target.dataset.mediaId;el.classList.toggle('is-active',active);el.setAttribute('aria-pressed',String(active));});
    };
    section.addEventListener('click', event=>{
      const thumb=event.target.closest('[data-media-target]');if(thumb)showMedia(thumb.dataset.mediaTarget);
      const arrow=event.target.closest('[data-gallery-step]');if(arrow && media.length){const i=media.findIndex(el=>!el.hidden);showMedia(media[(i+Number(arrow.dataset.galleryStep)+media.length)%media.length].dataset.mediaId);}
      const step=event.target.closest('[data-qty-step]');if(step){const input=section.querySelector('[name="quantity"]');input.value=Math.max(1,(Number(input.value)||1)+Number(step.dataset.qtyStep));}
    });
    const form=section.querySelector('.pdp-form');
    const add=form.querySelector('.pdp-add');
    const error=form.querySelector('[data-product-error]');
    const update=()=>{
      const selected=[...section.querySelectorAll('[data-option-position]')].map(group=>{
        const value=group.querySelector('input:checked')?.value;
        group.querySelector('[data-selected-option]').textContent=value || '';
        return value;
      });
      const variant=variants.find(v=>v.options.length===selected.length && v.options.every((value,index)=>value===selected[index]));
      form.querySelector('[data-variant-id]').value=variant?.id || '';
      const available=Boolean(variant?.available);
      add.disabled=!available;
      add.querySelector('[data-add-text]').textContent=available?add.dataset.addLabel:variant?add.dataset.soldLabel:add.dataset.unavailableLabel;
      const availability=section.querySelector('[data-availability]');
      availability.textContent=available?'● '+availability.dataset.inStock:variant?'● '+add.dataset.soldLabel:'● '+add.dataset.unavailableLabel;
      availability.classList.toggle('is-unavailable',!available);
      if(variant){
        section.querySelector('[data-product-price]').textContent=money(variant.price);
        const compare=section.querySelector('[data-compare-price]');
        compare.hidden=!(variant.compare_at_price>variant.price);
        compare.textContent=compare.hidden?'':money(variant.compare_at_price);
        section.querySelector('[data-sale-badge]').hidden=compare.hidden;
        if(variant.featured_media)showMedia(variant.featured_media.id);
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      }
      error.hidden=true;
    };
        form.addEventListener('change',event=>{if(event.target.matches('.pdp-choice input'))update();});
    form.addEventListener('submit',async event=>{
      if(!form.querySelector('[data-variant-id]').value){event.preventDefault();return;}
      event.preventDefault();add.disabled=true;error.hidden=true;
      try {
        const response=await fetch(`${root}cart/add.js`,{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
        const data=await response.json();if(!response.ok)throw Error(data.description || 'Could not add this item');
        await refreshCart();openPanel(cartPanel);
      } catch(err){error.textContent=err.message;error.hidden=false;}
      finally {add.disabled=!variants.find(v=>String(v.id)===form.querySelector('[data-variant-id]').value)?.available;}
    });
  }
  document.querySelectorAll('[data-product-section]').forEach(initProduct);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-product-section]').forEach(initProduct));
})();
